function k() {
    let d = 0,
        p = null;
const currencyConfig = {
  locale: window.Shopify?.locale || 'en-IN',
  currency: window.Shopify?.currency?.active || 'INR',
  rate: window.Shopify?.currency?.rate || 1
};

const x = 3,
  m = document
    .querySelector(".bab__container")
    ?.classList.contains("bab__container--edit") ?? false,
  B = new Intl.NumberFormat(currencyConfig.locale, {
    style: "currency",
    currency: currencyConfig.currency
  });

function y(e) {
  return B.format(e * currencyConfig.rate);
}

    const c = (function () {
            const e = JSON.parse(document.getElementById("bab-data").innerText),
                t = {};
            Object.keys(e.ids).forEach(function (a) {
                t[e.ids[a]] = e.prices[a];
            });
            return {
                prices: t,
                tiers: e.tiers,
                sellingPlans: e.sellingPlans,
                product: e.product,
                variants: e.variants
            };
        })(),
        S = c.tiers.reduce(function (e, t) {
            return Math.max(e, t.min_products);
        }, 0),
        _ = 1 / (S - 1),
        s = document.getElementById("bab-form");

    s.addEventListener("change", g);
    s.addEventListener("click", $);

    m &&
        new URLSearchParams(window.location.search).getAll("items").map((a) => {
            const [r, i] = a.split(":"),
                n = document.querySelector(`input[value='${r}']`);
            n != null && ((n.checked = !0), (n.closest(".bab__product").querySelector(".bab__product-qty-input").value = i));
        });

    function g() {
        C(), T(), P(), N(), O();
    }

    function q(e) {
        return s.querySelector('input[name="' + e.getAttribute("data-qty-target") + '"]');
    }

    function $(e) {
        if (e.target.matches("button[data-qty-target]")) {
            const t = q(e.target);
            (t.value = Math.max(0, Number.parseInt(t.value, 10) + Number.parseInt(e.target.getAttribute("data-qty-add"), 10))), g();
        }
    }

    function C() {
        s.querySelectorAll('button[data-qty-target][data-qty-add="-1"]').forEach(function (e) {
            const t = q(e);
            e.disabled = !(Number.parseInt(t.value, 10) > 0);
        });
    }

    function h() {
        return Array.from(s.querySelectorAll('input[name^="variant["]:checked')).map(function (e) {
            const t = e.value,
                a = Number.parseInt(s.querySelector('input[name="' + e.name.replace("variant", "qty") + '"]').value, 10);
            return { variantId: t, qty: a };
        });
    }

    function A() {
        const e = s.querySelector('[data-ref="progress-bar"]');
        e.innerHTML = [
            '<span data-ref="bar" class="bab__progress-bar-active-bar" style="width: 0%"></span>',
            ...c.tiers.map(function (t) {
                return `<span class="bab__progress-bar-marker" style="left: ${
                    (t.min_products - 1) * _ * 100
                }%"><span class="bab__progress-bar-content"><span data-ref="icon" class="bab__progress-bar-icon">🎉</span>${t.value * 100}% off</span></span>`;
            }),
            ...Object.keys([...Array(S)]).map(function (t) {
                return `<span
            data-ref="step"
            class="
              bab__progress-bar-step
              ${
                  c.tiers.findIndex(function (a) {
                      return a.min_products - 1 == t;
                  }) !== -1
                      ? "bab__progress-bar-step--threshold"
                      : ""
              }
            "
            style="left: ${t * _ * 100}%"
          ></span>`;
            }),
        ].join("");
    }

    function v() {
        let e = 0;
        return (
            s.querySelectorAll('input[name^="qty["]').forEach(function (t) {
                e += Number.parseInt(t.value, 10);
            }),
            e
        );
    }

    function T() {
        const e = s.querySelector('[data-ref="progress-bar"]'),
            t = v(),
            a = e.querySelectorAll('[data-ref="step"]');
        (e.querySelector('[data-ref="bar"]').style.width = Math.max(0, Math.min(1, (t - 1) * _)) * 100 + "%"),
            a.forEach(function (n, o) {
                n.classList[o < t ? "add" : "remove"]("active");
            });
        const r = e.querySelectorAll('[data-ref="icon"]'),
            i = c.tiers.map(function (n, o) {
                const u = Object.assign({}, n);
                return (u.element = r[o]), u;
            });
        i.forEach(function (n) {
            n.element.parentElement.classList[n.min_products <= t ? "add" : "remove"]("active");
        });
        if (m) {
            const n = i.find(function (o) {
                return t >= o.min_products;
            });
            n != null ? (p = "BOX-DISCOUNT-" + parseInt(n.value * 100, 10).toString()) : (p = null);
        }
    }

    function P() {
        let e = 0;
        const t = v(),
            a = s.querySelector('input[name="subscribe"]'),
            r = Boolean(a ? a.checked : 0),
            i = h(),
            n = I();

        i.forEach(({ variantId: l, qty: f }) => {
            if (r) {
                const L = c.variants.flat().find((b) => parseInt(l, 10) === b.id);
                if (L != null) {
                    const b = L.selling_plan_allocations.find((U) => U.selling_plan_id === parseInt(n, 10));
                    if (b != null) {
                        e += b.price * f;
                        return;
                    }
                }
            }
            e += c.prices[l] * f;
        });

        const o = c.tiers
                .sort((l, f) => f.min_products - l.min_products)
                .find((l) => l.min_products <= t),
            M = o ? o.value : 0;

        d = parseInt(e * M, 10);

        const w = e - d,
            E = e;

        s.querySelector('[data-ref="total-price"]').innerText = y(w / 100);
        s.querySelector('[data-ref="compare-price"]').innerText = E === w ? "" : y(E / 100);
        s.querySelector('[data-ref="savings"]').innerText = d > 0 ? y(d / 100) : "";
    }

    function I() {
        const e = document.getElementById("subscribe"),
            t = s.querySelector(".bab__select");
        return t && e != null && e.checked ? t.value : null;
    }

    function j() {
        const e = document.getElementById("subscribe"),
            t = s.querySelector(".bab__select");
        e &&
            (e.addEventListener("click", () => {
                e.checked ? t.classList.add("bab__select--active") : t.classList.remove("bab__select--active");
            }),
            t.addEventListener("change", () => {
                e.checked = !0;
            }),
            P());
    }

    function N() {
        const e = v(),
            t = s.querySelector(".bab__atc-btn");
        e >= x ? ((t.disabled = !1), t.classList.remove("disabled")) : ((t.disabled = !0), t.classList.add("disabled"));
    }

    s.addEventListener("submit", async (e) => {
        e.preventDefault();
        const t = h(),
            a = I(),
            r = c.product;

            await fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    attributes: { [`_box-${r.id}-savings`]: d },
                    items: t
                    .filter(({ qty }) => qty > 0)
                    .map(({ variantId, qty }) => ({
                        id: variantId,
                        quantity: qty,
                        properties: {
                        _box: `box-${r.id}`,
                        _parent_product_handle: `${r.handle}`,
                        _parent_product_id: `${r.id}`
                        },
                        ...(a ? { selling_plan: a } : {})
                    }))
                    .reverse()
                })
            });

        // ✅ Custom Feature: Remove ALL "recycled-measuring-scoop" items if present
        try {
            const cartResponse = await fetch("/cart.js");
            if (!cartResponse.ok) throw new Error("Failed to fetch cart");
            const cartData = await cartResponse.json();

            const scoopItems = cartData.items.filter(item => item.handle === "recycled-measuring-scoop");

            if (scoopItems.length) {
                // remove all matching line items in parallel, await completion
                await Promise.all(
                    scoopItems.map(item =>
                        fetch("/cart/change.js", {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify({
                                id: item.key,
                                quantity: 0
                            }),
                        }).then(res => {
                            if (!res.ok) return res.text().then(text => Promise.reject(new Error(text || "Failed to remove item")));
                            return res.json();
                        })
                    )
                );
                console.log(`Removed ${scoopItems.length} recycled-measuring-scoop item(s) from cart`);
            }
        } catch (error) {
            console.error("Error removing recycled-measuring-scoop:", error);
        }

        document.dispatchEvent(new CustomEvent("cart:applyBoxCoupons"));
        document.dispatchEvent(new CustomEvent("cart:build"));
        document.querySelector("a.site-nav__link.site-nav__link--cart.js-drawer-open-cart").click();
    });

    function O() {
        if (m) {
            const t = new URLSearchParams(window.location.search).get("edit"),
                a = c.product;
            document.querySelector(".bab__edit-badge--cancel").href = `/apps/juo/subscriptions/${t}`;
            const r = new URL(`/apps/juo/subscriptions/${t}`, window.location.origin);
            r.searchParams.append("update", 1),
                h().map(function (n) {
                    n.qty > 0 && r.searchParams.append("items", `${n.variantId}:${n.qty}`);
                }),
                p != null && r.searchParams.append("discountCode", p),
                r.searchParams.append("parentId", a.id),
                (document.querySelector(".bab__atc-btn--update").href = r.href);
        }
    }

    j(), A(), g();
}

document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", k) : k();
